import LeadAttachmentHistory from "./leadAttachmentHistory";
export default LeadAttachmentHistory;
